import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import { ReactNode } from 'react';

interface SearchCardProps {
  children: ReactNode;
  disabled?: boolean;
}

const SearchCard = ({ children, disabled = false }: SearchCardProps) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      data-testid="search-card"
      sx={{
        borderRadius: {
          xs: '10px',
          md: '50px',
        },
        overflow: 'hidden',
        backdropFilter: 'blur(20px)',
        backgroundColor: alpha(theme.palette.background.paper, 0.7),
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.08)',
        border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,

        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: disabled ? undefined : '0 12px 48px rgba(0, 0, 0, 0.12)',
          transform: disabled ? undefined : 'translateY(-4px)',
        },
        position: 'relative',
        maxWidth: '900px',
        mx: 'auto',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <Box sx={{ p: 1.5 }} data-testid="search-card-content">
        {children}
      </Box>
    </Paper>
  );
};

export default SearchCard;
